import React, { useState } from "react";
import Hero from "./Hero";
import Gallery from "./Gallery";
import About from "./About";
import Contact from "./Contact";
import Navigation from "./Navigation";
import Footer from "./Footer";

const Homepage = () => {
  const [activeTab, setActiveTab] = useState("home");

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-zinc-100">
      <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />
      
      {activeTab === "home" && <Hero setActiveTab={setActiveTab} />}
      {activeTab === "gallery" && <Gallery />}
      {activeTab === "about" && <About />}
      {activeTab === "contact" && <Contact />}
      
      {/* Footer on all pages */}
      <Footer />
    </div>
  );
};

export default Homepage;
